import React from "react";
import { useMsal } from "../../MsalContext";
import { getRedirectUri } from "../../authConfig";

import styles from "./LoginButton.module.css";
import { loginRequest } from "../../authConfig";
import { localStorageAuthUriKey } from "../../lsts"
interface LoginButtonProps {
    authorityURI: string;
    text: string;
    imgSrc: string;
    onAction: (resp: any) => void;
    isIFrame: boolean;
}

//export const LoginButton = () => {
export const LoginButton: React.FC<LoginButtonProps> = ({ authorityURI, text, imgSrc, onAction, isIFrame }) => {
    const { msalInstance, updateAuthority } = useMsal();

    const handleRedirectLogin = () => {
        if (msalInstance === null) {
            import.meta.env.DEV === true && console.log("‹handle_redir‾msalinstance_null›", authorityURI);
            return;
        }
        const activeAccount = msalInstance.getActiveAccount();
        const isLoggedIn = activeAccount != null;
        localStorage.setItem(localStorageAuthUriKey, authorityURI);

        import.meta.env.DEV === true && console.log("‹handle_redir›", authorityURI);
        if (msalInstance.getConfiguration().auth.authority != authorityURI) {
            import.meta.env.DEV === true && console.log("‹handle_redir‾local_user_flow_cache›", authorityURI);
            updateAuthority(authorityURI);
        }
        import.meta.env.DEV === true && console.log("‹handle_redir‾acquire_token_popup›", authorityURI);

        msalInstance.acquireTokenRedirect({
            scopes: loginRequest.scopes,
            authority: authorityURI,
            redirectUri: getRedirectUri()
        });
    };

    const handleLoginPopup = () => {
        if (msalInstance === null) {
            import.meta.env.DEV === true && console.log("‹handle_popup‾msalinstance_null›", authorityURI);
            return;
        }
        const activeAccount = msalInstance.getActiveAccount();
        const isLoggedIn = activeAccount != null;
        localStorage.setItem(localStorageAuthUriKey, authorityURI);

        import.meta.env.DEV === true && console.log("‹handle_popup›", authorityURI);
        if (msalInstance.getConfiguration().auth.authority != authorityURI) {
            import.meta.env.DEV === true && console.log("‹handle_popup‾update_local_user_flow_cache›", authorityURI);
            updateAuthority(authorityURI);
        }
        import.meta.env.DEV === true && console.log("‹handle_popup‾acquire_token_popup›", authorityURI);

        msalInstance
            .acquireTokenPopup({
                scopes: loginRequest.scopes,
                authority: authorityURI,
                redirectUri: getRedirectUri()
            })
            .then(response => {
                import.meta.env.DEV === true && console.log("‹handle_popup‾response›", authorityURI, response);
                onAction(response);
            })
            .catch(error => {
                import.meta.env.DEV === true && console.log("‹handle_popup‾errr›", error);
                if (error.name === "BrowserAuthError") {
                    import.meta.env.DEV === true && console.log("‹handle_popup‾browser_auth_errr›", error);

                    if (error.errorCode === "interaction_in_progress") import.meta.env.DEV === true && console.log("‹handle_popup‾popup_window_errr›");
                }
            });
    };

    return (
        <div className={`${styles.signinbuttons}`}>
            <button
                className={`${styles.signin} ${styles.microsoft}`}
                onClick={() => {
                    if (isIFrame == true) {
                        handleRedirectLogin();
                    } else {
                        handleLoginPopup();
                    }
                }}
            >
                <img src={imgSrc} alt="{text}"></img>
                {text}
            </button>
        </div>
    );
};
